<template>
  <v-container>
    <p>Lançamentos contabilidade</p>
    <div class="" style="display: flex; justify-content: start">
      <v-select
        class="mx-4"
        style="width: 500px"
        :items="filiais"
        label="Filial"
        placeholder="Filiais"
        persistent-placeholder
        clearable
        v-model="params.branches"
        multiple
      ></v-select>

      <div class="mx-4">
        <AutocompleteEnterprise
          label="Cliente"
          :items="optionsClientes"
          v-model="params.clients"
        ></AutocompleteEnterprise>
        <!-- <v-select
          :items="optionsClientes"
          label="Cliente "
          item-text="dpeNomPessoa"
          item-value="id"
          v-model="params.client"
        ></v-select> -->
      </div>

      <div class="mx-4">
        <DateInputDate
          v-model="params.dateStart"
          label="Data início"
          type="date"
        ></DateInputDate>
      </div>

      <div class="mx-4">
        <DateInputDate
          v-model="params.dateEnd"
          label="Data final"
          type="date"
        ></DateInputDate>
      </div>

      <div class="mx-4">
        <DateInputDate
          v-model="params.dateBatch"
          label="Data do lote"
          type="date"
        ></DateInputDate>
      </div>

      <div class="mx-4">
        <DateInputDate
          v-model="params.dateBatch2"
          label="Data do lote 2"
          type="date"
        ></DateInputDate>
      </div>

      <v-btn :disabled="loading" @click="ctbs()" class="primary mx-10"
        >Integrar

        <v-progress-circular
          v-show="loading"
          indeterminate
          color="white"
        ></v-progress-circular>
      </v-btn>
    </div>

    <br />

    <div>
      <p>Status da Integração.</p>

      <textarea
        v-if="ans"
        v-model="ans"
        style="width: 100%; height: 600px; background-color: lightgray"
      >
      </textarea>
    </div>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import DateInputDate from "../../components/fields/DateInputDate";
import DateInput from "../../components/fields/DateInput";
import roleIds from "../../../../libraries/strapi/rolesIds";
import AutocompleteEnterprise from "../../components/select/AutocompleteEnterprise.vue";
import strapiApi from "../../../../libraries/strapi/strapiApi";
import stmarieApi from "../../../../libraries/stmarie/stmarieApi";

export default {
  name: "Integration2",
  props: ["priCod"],
  components: { DateInputDate, DateInput, AutocompleteEnterprise },
  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),
    filCod() {
      return this.$route.query.filCod;
    },
  },

  data() {
    return {
      filiais: [1, 2, 3, 7, 20, 21, 22, 23, 24],
      params: {
        clients: [],
        dateStart: "",
        dateEnd: "",
        dateBatch: "",
        dateBatch2: "",
        branches: [],
      },
      selectedFilial: "01",
      lastDate: "",
      anomesDate: "",
      ans: ``,
      roleIds: roleIds,
      loading: false,
      optionsClientes: [],
      chipClientes: []
    };
  },
  async mounted() {
    this.lastDate = new Date().toISOString();
    this.anomesDate = new Date().toISOString().substring(0, 7);

    await this.loadEncomendantes();
  },
  methods: {
    async loadEncomendantes() {
      let encomendantes = await strapiApi.enterprises.getOptionsCtb006Despesa();

      this.encomendantes = encomendantes;

      this.optionsClientes = this.encomendantes.map((el) => ({
        id: el?.id,
        dpeNomPessoa: el?.dpeNomPessoa?.substring(0, 20),
      }));
    },
    async getProcesses() {},

    async ctb(branch, client) {
      try {
        let ans = await stmarieApi.ctb006_despesa(
          branch,
          client,
          new Date(this.params.dateStart?.substring(0, 10)).getTime(),
          new Date(this.params.dateEnd?.substring(0, 10)).getTime(),
          new Date(this.params.dateBatch?.substring(0, 10)).getTime(),
          new Date(this.params.dateBatch2?.substring(0, 10)).getTime()
        );
        this.ans = JSON.stringify(ans, null, 2);
      } catch (error) {
        this.ans = error;
      }

      this.loading = false;
    },

    async ctbs() {
      this.ans = "";
      this.loading = true;

      try {
        if (!this.params.branches?.length) {
          // alert("Preencher filiais");
          // this.loading = false;
          throw new Error("Preencher filiais");
        }
        if (!this.params.clients?.length) {
          throw new Error("Preencher clientes");
        }

        for (let i = 0; i < this.params.branches?.length; i++) {
          for (let j = 0; j < this.params.clients.length; j++) {
            let branch = this.params.branches[i];
            let client = this.params.clients[j];
            try {
              // if (!this.params.branches?.length)
              //   throw new Error("Preencher filial");

              if (!this.params.dateStart)
                throw new Error("Preencher data início");
              if (!this.params.dateEnd) 
                throw new Error("Preencher data fim");
              if (!this.params.dateBatch)
                throw new Error("Preencher data lote");
              if (!this.params.dateBatch2)
                throw new Error("Preencher data lote 2");

              this.ans += "\n\n";
              this.ans += `Filial ${branch}, Cliente: ${client}: \n\n`;

              let ans = await stmarieApi.ctb006_despesa(
                branch,
                client,
                new Date(this.params.dateStart?.substring(0, 10)).getTime(),
                new Date(this.params.dateEnd?.substring(0, 10)).getTime(),
                new Date(this.params.dateBatch?.substring(0, 10)).getTime(),
                new Date(this.params.dateBatch2?.substring(0, 10)).getTime()
              );
              //this.ans = JSON.stringify(ans?.saida, null, 2);

              this.ans += JSON.stringify(ans, null, 2);
            } catch (error) {
              this.ans += error;
            }
          }
        }
      } catch (error) {
        this.ans = error;
      }
      this.loading = false;
    },
  },
};
</script>

<style></style>
